import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextError } from "components/Utilities";

import { makeStyles } from "@mui/styles";
import { FormLabel, Grid } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  input: {
    ...theme.typography.input,
  },
  FormLabel: {
    "&.MuiFormLabel-root": {
      ...theme.typography.FormLabel,
    },
  },
}));

const Input = (props) => {
  const { label, name, ...rest } = props;
  const classes = useStyles();
  return (
    <Grid container direction="column" gap={1}>
      <FormLabel component="legend" className={classes.FormLabel}>
        {label}
      </FormLabel>
      <Field
        id={name}
        name={name}
        className={classes.input}
        {...rest}
        style={{ minHeight: 50 }}
      />
      <ErrorMessage name={name} component={TextError} />
    </Grid>
  );
};

export default Input;
